export { getRankBadge } from '../data/platformRanking';

/** Appendix B first-look slugs, without the -review suffix used on some routes. */
export const FIRST_LOOK_REVIEW_SLUGS = new Set([
  'ai-trans-chat-review',
  'lovechat-ai-review',
  'makegirl-ai-review',
  'krushchat-ai-review',
  'heaven-ai-review',
  'secretcrush-ai-review',
  'heygf-ai-review',
  'whatslove-ai-review',
  'yollo-ai-review',
  'ai-allure-review',
  'onlygfs-ai-review',
  'moonmate-review',
  'desirex-ai-review',
  'promptchan-review',
  'soulmate-review',
  'heavygirl-ai-review',
  'whatsapp-ai-review',
  'virtualgf-review',
  'magi-ai-review',
  'selira-ai-review',
  'dream-companion-review',
  'aigirlfriends-ai-review',
  'mybabes-ai-review',
  'infatuated-ai-review',
  'bonza-chat-review',
  'funfun-ai-review',
  'lustgf-review',
  'heyreal-ai-review',
  'virtualcrush-review',
  'justment-review',
  'reverie-review',
  'xeve-ai-review',
  'xchar-review',
  'virtualover-review',
  'openlover-review',
  'xotic-ai-review',
  'linky-ai-review',
  'polybuzz-ai-review',
  'talkie-ai-review',
  'dondi-ai-review',
  'secrets-ai-review',
  'kalon-ai-review',
  'kissable-review',
  'justsext-review',
  'soulkyn-review',
  'rubii-ai-review',
  'couple-me-review',
  'ai-girlfriend-com-review',
  'intimate-ai-review',
  'dreamle-review',
  'joi-ai-review',
  'lovel-ai-review',
  'flirtcam-ai-review',
]);

export const FIRST_LOOK_CHIP = 'First look · not yet fully tested · early signal score';

export const isFirstLookReview = (slug: string): boolean => FIRST_LOOK_REVIEW_SLUGS.has(slug);

const VERDICT_HEADING =
  /(Our Verdict|The Verdict|Quick Verdict)([^<\d]{0,48}?)(\d+(?:\.\d+)?)\s*\/\s*(?:5|10)\b/gi;

/** Replace hard-coded verdict and meta scores with the dataset value. */
export function alignScoreCopy(text: string, score: number): string {
  if (!text || !Number.isFinite(score) || score <= 0) return text;
  const formatted = score.toFixed(2);

  return text
    .replace(VERDICT_HEADING, (_match, label: string, gap: string) => {
      const separator = gap.includes('(') ? ' (' : ': ';
      return `${label}${separator}${formatted}/5`;
    })
    .replace(/(\d+(?:\.\d+)?)\s*\/\s*10\b/g, `${formatted}/5`)
    .replace(/\b(?:based on 10 points|10-point rating system)\b/gi, '5-point rating')
    .replace(/\btop-three\b/gi, 'highest-rated')
    .replace(/\bRUNNER UP\b/g, '');
}

export function alignMetaScore(text: string, score: number): string {
  if (!text || !Number.isFinite(score) || score <= 0) return text;
  const formatted = score.toFixed(2);
  return text.replace(/(\d+(?:\.\d+)?)\s*\/\s*5\b/g, `${formatted}/5`);
}

/**
 * Replace a review's own "Our #N" claim with its current overall rank.
 * Only for a review's title and meta, where "Our #N" always means that review.
 */
export function alignOverallRankCopy(text: string, rank: number | null): string {
  if (!text || rank === null) return text;
  return text.replace(/\b(our) #\d+\b/gi, (_match, our: string) => `${our} #${rank}`);
}
